<style scoped>

.custom-container {
  padding: 20px;
}

.custom-container .card {
  box-shadow: unset;
}

.custom-container .p-tabpanels {
  padding-left: 0;
  padding-right: 0;
}

.custom-container .p-accordionheader {
  padding-left: 0;
}

.custom-container .p-accordionheader p {
  margin: 0;
}

.custom-container .p-accordionheader .stato-esecutore {
  margin-left: auto;
  margin-right: 20px;
}
.row-tasks{
  grid-gap: 20px;
}
.row-tasks{
  grid-column-gap: 20px;
  justify-content: center;
  height: calc(100% - 102px);
}
.task-container.expanded {
  width: calc(80% - 20px);
}
.task-container.collapsed {
  width: calc(10% - 20px);
}
.filtri{
  padding: 20px 20px 0 20px;
}
.card{
  box-shadow: unset !important;
}

.row-hidden{
  position: absolute;
  width: calc(100vw - 20px);
  opacity: 0;
  visibility: hidden;
  top: 0;
  z-index: -1;
}
</style>

<template>
  <template v-if="isLoading==true">
    <h1 class="container-fluid mt-3">Attendi qualche istante</h1>
  </template>
  <template v-if="isLoading==false">
    <div class="container-fluid p-4">
          <div class="row row-tasks" >
<!--            <k-task-container-->
<!--                :user-id="userId"-->
<!--                :task-status="'BACKLOG'"-->
<!--                :is-p-m="false"-->
<!--            ></k-task-container>-->
            <k-task-container
                :user-id="userId"
                :expanded-on-start="true"
                :task-status="'TODO'"
                :is-p-m="false"
            ></k-task-container>
            <k-task-container
                :user-id="userId"
                :task-status="'REVIEW'"
                :is-p-m="false"
            ></k-task-container>
            <k-task-container
                :user-id="userId"
                :task-status="'DONE'"
                :is-p-m="false"
            ></k-task-container>
          </div>
    </div>
    <k-simple-modal></k-simple-modal>
    <k-modal-edit-task></k-modal-edit-task>
    <k-modal-dettaglio-ticket></k-modal-dettaglio-ticket>
    <k-modal-messaggio-task></k-modal-messaggio-task>
    <k-modal-storico-task></k-modal-storico-task>
    <CustomDialog v-model:visible="showCloseTicket" modal header="Tutti i Task Sprint completati" :style="{ width: '700px' }">
      <span class="text-surface-500 dark:text-surface-400 block mb-8">{{ titoloDialog }}</span>
      <div class="flex justify-end gap-2" style="grid-gap: 20px; display: flex; margin-top: 20px">
        <CustomButton type="button" label="Annulla" severity="secondary" @click="showCloseTicket=false"></CustomButton>
        <CustomButton type="button" severity="primary" label="Chiudi il ticket" @click="chiudiTicket"></CustomButton>
      </div>
    </CustomDialog>


<!--    <div class="container-fluid p-4">-->
<!--      <div class="row row-tasks row-hidden">-->
<!--        <k-task-container :user-id="-1" :task-status="'BACKLOG'"-->
<!--                          :is-p-m="true"></k-task-container>-->
<!--        <k-task-container :user-id="-1" :expanded-on-start="true"-->
<!--                          :task-status="'TODO'" :is-p-m="true"></k-task-container>-->
<!--        <k-task-container :user-id="-1" :task-status="'REVIEW'"-->
<!--                          :is-p-m="true"></k-task-container>-->
<!--        <k-task-container :user-id="-1" :task-status="'DONE'"-->
<!--                          :is-p-m="true"></k-task-container>-->
<!--      </div>-->
<!--    </div>-->
  </template>
</template>


<script>

import KTaskContainer from "@/views/taskSprint/components/task-container.vue";
import KModalEditTask from "@/views/taskSprint/components/modal-edit-task.vue"
import KSimpleModal from "@/views/taskSprint/components/simple-modal.vue"
import axios from "axios";
import KModalDettaglioTicket from "@/views/taskSprint/components/modal-dettaglio-ticket.vue";
import KModalMessaggioTask from "@/views/taskSprint/components/modal-messaggio-task.vue";
import KFiltriDashboard from "@/views/taskSprint/dashboard/components/filtri.vue";
import CustomDialog from "primevue/dialog";
import CustomButton from "primevue/button";
import KModalStoricoTask from "@/views/taskSprint/components/modal-storico-task.vue";

export default {
  name: "dashboard",
  components: {
    KModalStoricoTask,
    CustomButton,
    CustomDialog, KModalMessaggioTask, KModalDettaglioTicket, KTaskContainer, KModalEditTask,KSimpleModal},
  emits: ["show-modal"],
  data() {
    return {
      selectedTask:{},
      loggedUser: {},
      loading: true,
      contexts: [],
      hoveredIndex: null,
      userId:-1,
      showCloseTicket:false,
      titoloDialog:'',
      task:{},
      force:false,
    };
  },
  computed: {
    isLoading() {
      return this.loading;
    }
  },
  async mounted() {
    this.$store.dispatch("initializeSocket",sessionStorage.getItem('ACCESS_TOKEN'))
    await this.load();
  },
  created() {

    setInterval(async()=>{
      await this.load();
    }, 360000)
    // this.$watch(
    //     () => {
    //       sessionStorage.setItem("ACCESS_TOKEN", this.$route.params.ACCESS_TOKEN);
    //     },
    //     (newId, oldId) => {
    //       sessionStorage.setItem("ACCESS_TOKEN", this.$route.params.ACCESS_TOKEN);
    //     }
    // )
    this.$store.subscribe(async (mutation, state) => {
      if (mutation.type === 'tuttiITaskCompletati') {
        let task = { ...mutation.payload.task };
        let canCloseTicket=mutation.payload.canCloseTicket;
        let attivita = this.$store.getters.getTicket(task.idTicket);
        let esecutore= this.$store.getters.getEsecutoriFilter(task.idOwner+"");
        this.force=mutation.payload.force;
        if(canCloseTicket){
          this.showCloseTicket=true;
          this.titoloDialog="Tutti i Task Sprint per l'attività " + task?.titoloAttivita + " sono in stato DONE, vuoi chiudere il ticket";
          this.task={...task};
        }
      }
    })
  },
  methods: {
    async load() {
      this.loading = false;
      let filters={
        status:this.taskStatus
      }
      const config = {
        headers: { Authorization: `Bearer ${sessionStorage.getItem('ACCESS_TOKEN')}` }
      };
      let request= axios.post(process.env.VUE_APP_TASK_SPRINT_API+ "/task-sprint/getConfigForUserFromToken",{},{...config});
      let response= await request;
      let userDataToken=JSON.parse(response.data.result);
      sessionStorage.setItem('userId', userDataToken.user.userId)
      sessionStorage.setItem('ticketCategorie', JSON.stringify(userDataToken.idTicketCategorie))

      this.userId=Number.parseInt(userDataToken.user.userId);
      this.$store.dispatch("loadTasks",filters);
      this.$store.dispatch("loadEsecutori", filters);
      // this.$store.dispatch("loadLavori");
      // this.$store.dispatch("loadAttivitaSenzaLavoro");
      // this.$store.dispatch("loadTutteLeAttivita");
      // setInterval(()=>{
      //   let lastFetch=this.$store.getters.getLastFetch();
      //
      //   this.$store.dispatch('refreshTasks',{
      //     lastFetch:lastFetch,
      //     isPM:false
      //   });
      // }, 300000)
    },
    chiudiTicket(){
      this.$store.dispatch('chiudiTicket', { idOwner: this.task.idOwner, idTicket:this.task.idTicket, force:this.force });
      this.showCloseTicket=false;
    },
  }
};
</script>